export default "__VITE_ASSET__9ac02803__"